<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputCheckboxToggle" });
import "tailwindcss/tailwind.css";
import { onMount } from "svelte";
import { v4 as uuid } from "uuid";
export let name;
export let label = "";
export let isChecked = false;
export let isDisabled = false;
export let isRequired = false;
export let isIndeterminate = false;
export let css = "";
export let size = "md";
export let align = "left";
export let color = "dark";
let id = "";
let isError = false;
const validate = (event) => {
    if (event.target === null) {
        return;
    }
    isError = !event.target.validity.valid;
};
const onChange = (event) => {
    const TARGET = event.target;
    isChecked = TARGET.checked;
    validate(event);
};
onMount(() => {
    id = uuid();
});
</script>

<input
    type = 'checkbox'
    checked = { isChecked }
    disabled = { isDisabled }
    required = { isRequired }
    indeterminate = { !isChecked && isIndeterminate }
    value = { true }
    { id }
    { name }
    on:invalid = { validate }
    on:change = { onChange }
    on:change
/>

<label for = { id } class = { `s8-input-checkbox-toggle ${ css } s8-${ size } s8-${ align } s8-${ color }`}>
    <slot { isChecked } { isDisabled } { isError }>{ label }</slot>
</label>

<style>

    label.s8-input-checkbox-toggle {
            position: relative;
            display: inline-block;
            width: 100%;
            cursor: pointer;
            -webkit-user-select: none;
               -moz-user-select: none;
                    user-select: none;
            line-height: 1
}

        label.s8-input-checkbox-toggle:before {
            position: absolute;
            top: 50%;
            --tw-translate-y: -50%;
            transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
            border-width: 1px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 150ms;
            content: ''
}

        label.s8-input-checkbox-toggle.s8-left:before {
            left: 0px
}

        label.s8-input-checkbox-toggle.s8-right:before {
            right: 0px
}

        label.s8-input-checkbox-toggle.s8-md:before {
            height: 0.75rem;
            width: 0.75rem;
            border-radius: 0.125rem
}

        label.s8-input-checkbox-toggle.s8-md.s8-left {
            padding-left: 1rem
}

        label.s8-input-checkbox-toggle.s8-md.s8-right {
            padding-right: 1rem
}

        label.s8-input-checkbox-toggle.s8-lg:before {
            height: 1rem;
            width: 1rem;
            border-radius: 0.125rem
}

        label.s8-input-checkbox-toggle.s8-lg.s8-left {
            padding-left: 1.25rem !important
}

        label.s8-input-checkbox-toggle.s8-lg.s8-right {
            padding-right: 1.25rem !important
}

    input {
            display: none
}

    input:invalid + label {
            color: rgba(239, 35, 59, 1)
}

    input:disabled + label {
            cursor: not-allowed;
            color: rgba(193, 192, 189, 1)
}

    input:disabled + label:before {
            border-color: rgba(231, 231, 230, 1)
}

    input:disabled:checked + label,
        input:disabled:indeterminate + label {
            cursor: not-allowed;
            color: rgba(193, 192, 189, 1)
}

    input:disabled:checked + label:before, input:disabled:indeterminate + label:before {
            border-color: rgba(231, 231, 230, 1);
            background-color: rgba(231, 231, 230, 1)
}

    input:checked + label:before {
            border-color: rgba(39, 39, 17, 1);
            background-color: rgba(39, 39, 17, 1);
                background-image: url('https://cdn.smatch.com/assets/check.svg')
}

    input:indeterminate + label:before {
            border-color: rgba(39, 39, 17, 1);
            background-color: rgba(39, 39, 17, 1);
                background-image: url('https://cdn.smatch.com/assets/indeterminate.svg')
}

    input:not(:disabled):not(:checked):not(:indeterminate) + label:before {
            border-color: rgba(212, 211, 209, 1);
            background-color: rgba(255, 255, 255, 1)
}

    input:not(:disabled):not(:checked):not(:indeterminate) + label:hover:before {
            border-color: rgba(151, 150, 145, 1)
}</style>